const RETURN_URL_KEY = "auth-return-url";

export function isSafeReturnPath(
  path: string | null | undefined
): path is string {
  if (!path || !path.startsWith("/") || path.startsWith("//")) {
    return false;
  }
  const pathname = path.split("?")[0].split("#")[0];
  return pathname !== "/login" && pathname !== "/reset";
}

export function saveReturnUrl(
  path: string = window.location.pathname + window.location.search
): void {
  if (isSafeReturnPath(path)) {
    sessionStorage.setItem(RETURN_URL_KEY, path);
  }
}

export function consumeReturnUrl(): string {
  const stored = sessionStorage.getItem(RETURN_URL_KEY);
  sessionStorage.removeItem(RETURN_URL_KEY);
  return isSafeReturnPath(stored) ? stored : "/home";
}

export function clearReturnUrl(): void {
  sessionStorage.removeItem(RETURN_URL_KEY);
}
